import { Box, Stack, Typography, Paper, Avatar } from '@mui/material';
import Timer from '../Timer';

export default function MultiplayerOpponentBar({ opTime, setOpTime, turn, opGameMode, gameState, roomID }) {
    return (
        <Paper elevation={3} sx={{ p: { xs: 0.5, sm: 1 }, width: '100%', backgroundColor: '#36454F', color: 'white' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                {/* Left: Avatar, Name, Mode, and Timer */}
                <Stack direction="row" spacing={{ xs: 1, sm: 1.5 }} alignItems="center" sx={{ ml: { xs: 1, sm: 2 } }}>
                    <Avatar sx={{ bgcolor: 'primary.main', width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 }, fontSize: { xs: '1rem', sm: '1.2rem' } }}>Op</Avatar>
                    <Typography variant="body2" sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>
                        Opponent ({opGameMode})
                    </Typography>
                    <Timer
                        minSecs={opTime}
                        setTime={setOpTime}
                        isRunning={!turn && gameState === 'start'}
                    />
                </Stack>
                {/* Right: Room ID */}
                <Typography variant="body2" sx={{ mr: { xs: 1, sm: 4 }, fontWeight: 'bold', fontSize: { xs: '0.9rem', sm: '1rem' } }}>
                    RoomID: {roomID}
                </Typography>
            </Box>
        </Paper>
    );
}